import { SelectedDateSelector, SelectedMealTypeSelector, UserMealPlanDataSelector } from '../../app/mealPlan/mealPlan.slice'
import { useAppSelector } from '../../app/store/hooks'
import { Redirect } from 'react-router-dom';
import {  useState } from 'react';
import RecipeForm from '../../components/mealPlanPage/RecipeForm';
import Grid from '@mui/material/Grid';
import styles from './AddMeal.module.css'

const AddMealToMealPlan = () => {
    const selectedMealType = useAppSelector(SelectedMealTypeSelector);
    const selectedDate = useAppSelector(SelectedDateSelector);

    const [selectedRecipeIds, setSelectedRecipeIds] = useState<Map<string, { servingSize: number }>>(new Map());


    if (!selectedDate || !selectedMealType) {
        return <Redirect to="/meal-plan" />
    }
    return (
        <Grid className={styles.add_meal_container}>
            <RecipeForm selectedRecipeIds ={selectedRecipeIds} setSelectedRecipeIds = {setSelectedRecipeIds} />
            
        </Grid>
    )
}

export default AddMealToMealPlan
